module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("flex " + _vm.justify + " " + _vm.divClass)
  }, [_c('img', {
    staticClass: "mr1 self-start",
    staticStyle: {
      "margin-right": "5px",
      "min-width": "20px",
      "margin-top": "1px"
    },
    style: (_vm.svgStyle),
    attrs: {
      "src": _vm.svg,
      "alt": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "inter",
    class: _vm.labelClass,
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f439cf3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f439cf3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconWithText.vue
// module id = 1448
// module chunks = 0